import { Theme } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme: Theme) => ({
  background: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
  },
  title: {
    marginTop: 0,
  },
  loader: {
    marginTop: "40vh",
  },
  learnerTable: {
    padding: "16px",
    [theme.breakpoints.down('md')]: {
      padding: "16px 10px 16px 8px",
    },
  },
  learnerGridBox: {
    width: "98vw",
    height: "40vh",
    [theme.breakpoints.down('sm')]: {
      width: "98vw",
      height: "65vh",
    },
  },
}));
